export default __webpack_public_path__ + "static/media/FITUR QIANA 4.6c10ced3.png";